import React, { Component } from 'react';

class Team extends Component {
    constructor(props) {
        super(props);

        const data = props.data;
        this.state = {
            data: data,
            tooltip: data.tooltip,
            background: data.background,
            blurb: data.blurb,
        };
    }

    render() {
        const section = {
            background: `linear-gradient(rgba(0, 0, 0, 0.50), rgba(0, 0, 0, 0.15)), url(${this.state.background}) no-repeat center center`,
            backgroundSize: 'cover',
            textAlign: 'left',
        };

        const mainContainer = {
            height: 'inherit',
        };

        return (
            <div className="section" data-tooltip={this.state.tooltip} style={section}>
                <div className="container-fluid p-4 d-flex flex-column justify-content-start" style={mainContainer}>
                    <div className="container container-width p-4">
                        <div className="row p-4" >
                            <div className="col-xs-8 col-md-5">
                                <h5>"{this.state.blurb}"</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default Team;



// WEBPACK FOOTER //
// ./src/pages/team.js